export default __webpack_public_path__ + "static/media/hewlett-packard.a76f30bd.svg";